import * as React from 'react';
import { getPortalPageSectionTypes } from 'helpers/pagesections';
import { Modal } from 'components';
import { IDropdownData } from 'models/common';
import { IModalAction } from 'models/modal';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { PortalPageSection } from 'components/PortalStructure';
require('./style.css');

interface IProps {
	addSection?: (sectionType: string) => void;
	closeModal: Redux.ActionCreator<IModalAction>;
	showHeaderCloseButton: boolean;
	t?: (key: string) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalPageSectionSelector extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public onSubmit(key: string) {
		this.props.addSection(key);
	}

	public render() {
		const { t, showHeaderCloseButton, closeModal } = this.props;
		const sectionTypes: IDropdownData[] = getPortalPageSectionTypes();
		const buttons = sectionTypes.map((item: IDropdownData) => {
			return (
				<div key={item.key}>
					<input
						key={item.key}
						className="sectionSelectorButton"
						type="button"
						onClick={() => this.onSubmit(item.key)}
						value={item.value}
					/>
				</div>
			);
		});

		return (
			<Modal
				title={t('PortalPage_Sections_SectionSelector_Title')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				modalClass="sectionSelectorPortalPage"
			>
				<PortalPageSection usage="admin">{buttons}</PortalPageSection>
			</Modal>
		);
	}
}

export { PortalPageSectionSelector };
